import { useCallback } from 'react';
import { isNativeWebview } from '|/helpers/is-native-app';
import { MobileWebviewEvents } from '|/helpers/mobile-webview-events';
import sendNativeEvent from '|/helpers/send-native-event';

const useNavigateAwayFromPurchase = () =>
  useCallback((path: string) => {
    if (isNativeWebview()) {
      sendNativeEvent({
        event: MobileWebviewEvents.CONTINUE_TO_SRP,
        url: path,
        source: 'purchase'
      });
      return;
    }
    window.location.href = path;
  }, []);

export default useNavigateAwayFromPurchase;
